import { $ } from "../../third-party-imports";
import { getKeywordSearchElement } from "./getKeywordSearchElement";

export function keywordSearch(g2Data: any)
{
    const searchEl = getKeywordSearchElement();
    const searchValue = searchEl?.value?.trim() ?? "";
    const searchRegex = /^[a-zA-Z0-9-\s]+$/g;
    const errMsg = document.querySelector('#searchInputErrMsg');
    // Check whether search keyword is valid or not
    if (!searchRegex.test(searchValue))
    {
        if (errMsg)
            return;

        const errorElem = `<div class="error help-block invalid-feedback" id="searchInputErrMsg" style="visibility: visible;margin-left: 60px;">Please enter a valid search term</div>`;
        $('.srchBtnn').after(errorElem);

        if (g2Data.response.numFound === 0)
        {
            $('.pagination-box').remove();
        }

        return;
    }

    if (errMsg)
    {
        $('#searchInputErrMsg').remove();
    }

    if (!searchValue)
        return;
    // replace space with '-'
    let searchTermUpdated = searchValue.replace(/\s/g, '-');
    searchTermUpdated = searchTermUpdated.replace(/\'/g, '#');
    let linkHref = window.location.href.toLowerCase();
    if (linkHref.split("/")[5] != undefined) {
        if (linkHref.split("/")[5].indexOf("expert-tips") != -1) {
            window.location.href = encodeURI(`${window.location.origin}/${linkHref.split("/")[3]}/${linkHref.split("/")[4]}/expert-tips/search/${encodeURIComponent(searchTermUpdated)}`);
            window.postMessage('keywordSearch', undefined, undefined);
        }
        else{
            window.location.href = encodeURI(`${window.location.origin}/expert-tips/search/${encodeURIComponent(searchTermUpdated)}`);
            window.postMessage('keywordSearch', undefined, undefined);
        }
    }
    else{
        window.location.href = encodeURI(`${window.location.origin}/expert-tips/search/${encodeURIComponent(searchTermUpdated)}`);
        window.postMessage('keywordSearch', undefined, undefined);
    }
    
}
